export default "__VITE_ASSET__D9aqrm3C__"